import Download from '@/apps/index/mixins/download'
import ScrollToTop from '@/apps/index/mixins/scrollToTop'
import { getInitInfo, getRegions, paperList } from '@/apps/index/models/api'
import { NoResult, PaperItem } from '@/components'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import LessInfo from '@/components/LessInfo'
import MainTemplate from '@/components/MainTemplate.vue'
import { Component, Mixins, Watch } from 'vue-property-decorator'
// 直辖市
const DIRECT_CITIES = ['北京', '天津', '重庆', '上海', '北京市', '天津市', '重庆市', '上海市']
const TERM_CHOICE = [
  [0, '全部'],
  [1, '上学期'],
  [2, '下学期']
]
@Component({
  components: {
    MainTemplate,
    SingleRowSelect,
    NoResult,
    PaperItem,
    LessInfo,
    SmallBtnSkeleton
  }
})
export default class PaperList extends Mixins(Download, ScrollToTop) {
  public analysisList: number[] = [] // 分析试卷总数
  public provinceChoice: any[] = []
  public gradeChoice = []
  public yearChoice = []
  public termChoice: any[] = []
  public papertypeChoice: any[] = []
  public cityChoice: any[] = []
  public sectionChoice: any[] = []
  public flag = true
  public keyword = ''
  // 试卷信息
  public contentData = []
  public page = 1
  public perPage = 10
  public total = 0
  public loading = true // 初始化loading为true，默认应该为pending状态
  public loadingModal = false
  // 筛选条件
  public pageTotal = 0 //
  // 获取省市区
  public province = (this.regions && this.regions[0]) || { code: 0, name: '全部' }
  public grade = [0, '全部']
  public city = { code: 0, name: '全部' }
  public section = { code: 0, name: '全部' }
  public year = [0, '全部']
  public paperType = [0, '全部']
  public term = [0, '全部']
  public checkUserOk = false
  // 筛选条件状态，默认为 true
  public optionsLoading = true
  // 获取学科
  private get subject() {
    return this.$store.state.subject
  }
  // 验证登录成功
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  // 用户地区
  private get regions() {
    const user = this.$store.state.user_info
    const regions = user && user.regions
    return regions
  }
  // 打点moduleName
  private get moduleName() {
    return this.$route.meta.label
  }
  // 展示状态
  public get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.contentData.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  // 用户信息
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  // 市、区显示控制
  public get showName() {
    if (!(this.province && this.province.name)) return
    return DIRECT_CITIES.indexOf(this.province.name) > -1 ? '区：' : '市：'
  }
  // 获取默认市列表
  @Watch('regions', { deep: true })
  public onRegionsChange(val) {
    if (val && val.length > 0) {
      this.province = val[0]
      this.city = { code: 0, name: '全部' }
      this.section = { code: 0, name: '全部' }
      this.getRegions(val[0].code, 'city')
    }
  }
  // 学科切换
  @Watch('subject', { immediate: true })
  public onSubjectChange(val) {
    if (val && val.value) {
      if (![202, 203].includes(val.value)) {
        window.location.href = '/'
        return
      }
      this.analysisList = []
      this.getInitInfo()
      this.reset()
      this.getList(1)
    }
  }
  // 获取条件信息
  public async getInitInfo() {
    try {
      this.optionsLoading = true
      const data: any = await getInitInfo({ subject_id: this.subject && this.subject.value })
      if (data.success) {
        this.provinceChoice = [{ code: 0, name: '全部' }, ...data.data.region_choices]
        this.gradeChoice = data.data.grade_choices
        this.yearChoice = data.data.year_choices
        this.termChoice = TERM_CHOICE
        this.papertypeChoice = [[0, '全部'], ...data.data.paper_type_choices]
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  // 点击展开/收起
  public switchIt(val: boolean) {
    this.flag = !this.flag
  }
  // 试卷详情
  public paperDetail(data) {
    window.open(
      `/detail?_id=${data.paper_id}&subject_id=${this.subject.value}&assemble=${data.is_assemble ? 1 : 0}`
    )
  }
  // 地区（省）
  public clickRegion(item) {
    this.province = item
    // 市、区重置
    this.city = { code: 0, name: '全部' }
    this.section = { code: 0, name: '全部' }
    if (item && item.name === '全部') {
      this.cityChoice = []
      this.sectionChoice = []
    }
    this.getRegions(item.code, 'city')
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '地区',
      value: item.name,
      paper_type: ''
    })
  }
  // 市
  public clickCity(item) {
    this.city = item
    // 区重置
    this.section = { code: 0, name: '全部' }
    if (item && item.name === '全部') {
      this.sectionChoice = []
    }
    this.getRegions(item.code, 'district')
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '市',
      value: item.name,
      paper_type: ''
    })
  }
  // 区
  public clickSection(item) {
    this.section = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '区',
      value: item.name,
      paper_type: ''
    })
  }
  // 选择年级
  public clickGrade(item) {
    this.grade = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年级',
      value: item[1],
      paper_type: ''
    })
  }
  // 试卷类型
  public clickPaperType(item) {
    this.paperType = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '类型',
      value: item[1],
      paper_type: ''
    })
  }
  // 年份
  public clickYear(item) {
    this.year = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年份',
      value: item[1],
      paper_type: ''
    })
  }
  // 选择学期
  public clickTerm(item) {
    this.term = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '学期',
      value: item[1],
      paper_type: ''
    })
  }
  // 切换分页
  public onPageChange(val) {
    this.getList(val)
    this.scrollTo(0) // 滚动到顶
  }
  // 搜索
  public onSearch() {
    // 搜索打点
    window['sensors'].track('TIKU_search', {
      moduleName: this.moduleName,
      keyword: this.keyword || ''
    })
    this.getList(1)
  }
  // 清空搜索内容
  public onKeywordchange() {
    const txt = String(this.keyword).trim()
    if (txt === '') {
      this.getList(1)
    }
  }
  // 重置
  public reset() {
    this.keyword = ''
    this.contentData = []
    this.page = 1
  }
  // 获取地区信息
  public async getRegions(val, type) {
    if (val !== 0) {
      let obj = {
        pcode: val
      }
      try {
        const { data } = await getRegions(obj)
        if (type === 'city') {
          this.cityChoice = [{ code: 0, name: '全部' }, ...data]
        } else {
          if (data && data.length) {
            this.sectionChoice = [{ code: 0, name: '全部' }, ...data]
          } else {
            this.sectionChoice = []
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
  // 全选事件
  public changeAll() {
    this.contentData.forEach((item: any) => {
      item.checked = true
      // tslint:disable-next-line:no-unused-expression
      !this.analysisList.includes(item.paper_id) && this.analysisList.push(item.paper_id)
    })
  }
  // 单一选择事件
  public onChange(e, item) {
    item.checked = e.target.checked
    if (e.target.checked) {
      // tslint:disable-next-line:no-unused-expression
      !this.analysisList.includes(item.paper_id) && this.analysisList.push(item.paper_id)
    } else {
      const idx = this.analysisList.indexOf(item.paper_id)
      // tslint:disable-next-line:no-unused-expression
      idx >= 0 && this.analysisList.splice(idx, 1)
    }
  }
  // analysisStart
  public analysisStart() {
    if (this.analysisList.length > 12) {
      this.$warning({
        title: '已超过最大限制',
        content: '每次分析最多可选择12套试卷～'
      })
      return
    }
    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.moduleName,
      functionName: '试卷分析：开始分析'
    })
    window.open(`/paperAnalysis/detail?ids=${this.analysisList.toString()}`)
  }
  // 试卷列表
  // tslint:disable-next-line:cyclomatic-complexity
  public async getList(page: number) {
    let regionCode = this.province && this.province.code
    if (!~~this.subject.value) {
      return
    }
    if (this.section && this.section.code) {
      regionCode = this.section.code
    } else if (this.city && this.city.code) {
      regionCode = this.city.code
    }
    this.page = Number(page)
    let obj: any = {
      subject_id: ~~this.subject.value,
      region_code: regionCode,
      city: this.city && this.city.code,
      district: this.section && this.section.code,
      year: this.year[0],
      grade: this.grade && this.grade[0],
      keyword: this.keyword || '',
      page: this.page,
      for_local_analysis: true,
      per_page: this.perPage,
      is_excellent: true,
      is_famous_school: false,
      sort_type: 1,
      paper_type: this.paperType && this.paperType[0],
      term: this.term[0]
    }
    if (!this.loading) {
      this.loading = true
    }
    try {
      const { data, total }: any = await paperList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        data.forEach(item => item.checked = this.analysisList.includes(item.paper_id) ? true : false)
        this.contentData = data
        this.total = total
        if (this.total >= 100 * this.perPage) {
          this.pageTotal = 100 * this.perPage
        } else {
          this.pageTotal = this.total
        }
      } else {
        this.contentData = []
        this.total = 0
      }
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.contentData = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }
}
